import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    users: [],
    usersLoading: false,
    devices: [],
    devicesLoading: false,
  },
  mutations: {
    setList(state, deployments) {
      state.list = deployments;
    },
    setListLoading(state, loading) {
      state.listLoading = loading;
    },
    setUsersLoading(state, loading) {
      state.usersLoading = loading;
    },
    setDevicesLoading(state, loading) {
      state.devicesLoading = loading;
    },
    setUsers(state, users) {
      state.users = users;
    },
    setDevices(state, devices) {
      state.devices = devices;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let deployments = await api.get("deployments");
      commit("setList", deployments.data);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      delete payload.organizations_id;
      await api
        .post("deployments", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      dispatch("ownerships/loadAll", null, { root: true });
      dispatch("devices/loadAll", null, { root: true });
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("deployments", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async endDeployment({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("deployments/endDeployment", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async grantUserDeploymentAccess({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("user/grantDeploymentAccess", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      dispatch("loadDeploymentUsers", payload.deployments_id);
      dispatch("loadDeploymentDevices", payload.deployments_id);
      return returnData;
    },
    async alterDeploymentDevice({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("deployment/alterDevices", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      dispatch("loadDeploymentDevices", payload.deployments_id);
      return returnData;
    },
    async loadDeploymentUsers({ commit }, deploymentID) {
      commit("setUsersLoading", true);
      let users = await api.get("deployment/users", {
        params: {
          deploymentID: deploymentID
        }
      });
      commit("setUsers", users.data);
      commit("setUsersLoading", false);
    },
    async loadDeploymentDevices({ commit }, deploymentID) {
      commit("setDevicesLoading", true);
      let devices = await api.get("deployment/devices", {
        params: {
          deploymentID: deploymentID
        }
      });
      commit("setDevices", devices.data);
      commit("setDevicesLoading", false);
    }
  },
  getters: {
    listLoading(state) {
      return state.listLoading;
    },
    list(state) {
      return state.list;
    },
    usersLoading(state) {
      return state.usersLoading;
    },
    users(state) {
      return state.users;
    },
    devices(state) {
      return state.devices;
    },
    devicesLoading(state) {
      return state.devicesLoading;
    },
  }
};
